import { useAuth } from '@context/AuthContext'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { HomeContainer } from './HomePage.styles'

const HomePage: React.FC = () => {
	const navigate = useNavigate()
	const { user } = useAuth()

	// For now, redirect to trips page
	React.useEffect(() => {
		navigate('/trips', { replace: true })
	}, [navigate])

	return (
		<HomeContainer>
			<h1>Welcome back, {user?.firstName}!</h1>
			<p>Redirecting to your trips...</p>
		</HomeContainer>
	)
}

export default HomePage
